import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-40f0c12a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-variable-list-empty-content" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "component-variable-list-empty-content__text" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, " Try different keywords, more general keywords or fewer keywords ", -1 /* HOISTED */));
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "component-variable-list-empty-content__text" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "No settings match your filters."),
    /*#__PURE__*/ _createElementVNode("h2", null, " Try adjusting or removing some filters to broaden your search ")
], -1 /* HOISTED */));
import noFilterResultsImage from "assets/extole-report-no-data.png";
import noSearchResultsImage from "assets/extole-report-no-reports-found.png";
import { hasNoResults } from "../filter/isComponentVariableShown";
import { computed, toRef } from "vue";
import { isFilteringComponentVariables, isTextSearchingComponentVariables, useComponentVariableMutableFilter, } from "src/shared/store/component-variable-mutable/composables/useComponentVariableMutableSetFilter";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableListEmptyContent',
    props: {
        componentMutableKey: {}
    },
    setup(__props) {
        const props = __props;
        const noResults = computed(() => {
            return hasNoResults(props.componentMutableKey);
        });
        const isFiltering = computed(() => {
            return isFilteringComponentVariables(props.componentMutableKey);
        });
        const isSearching = computed(() => {
            return isTextSearchingComponentVariables(props.componentMutableKey);
        });
        const showEmptyContent = computed(() => {
            return noResults.value && isFiltering.value;
        });
        const { componentVariableMutableFilter } = useComponentVariableMutableFilter(toRef(props, "componentMutableKey"));
        const search = computed(() => {
            return componentVariableMutableFilter.value.search;
        });
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                (isSearching.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("img", {
                            src: _unref(noSearchResultsImage),
                            alt: "No reports to show"
                        }, null, 8 /* PROPS */, _hoisted_2),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("p", null, [
                                _createTextVNode(" Your search "),
                                _createElementVNode("strong", null, "“" + _toDisplayString(search.value) + "”", 1 /* TEXT */),
                                _createTextVNode(" doesn't match any settings. ")
                            ]),
                            _hoisted_4
                        ])
                    ], 64 /* STABLE_FRAGMENT */))
                    : (isFiltering.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("img", {
                                src: _unref(noFilterResultsImage),
                                alt: "No reports to show"
                            }, null, 8 /* PROPS */, _hoisted_5),
                            _hoisted_6
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
            ], 512 /* NEED_PATCH */)), [
                [_vShow, showEmptyContent.value]
            ]);
        };
    }
});
